import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import router from "./routes.tsx";
import "./styles/index.css";

// PERF: Performance monitoring - mark app start time
performance.mark("app-start");

// Log performance measures when available
const logPerformance = () => {
  try {
    const measures = performance.getEntriesByType("measure");
    if (measures.length > 0) {
      console.log(
        "[PERF] Performance measures:",
        measures.map((m) => ({ name: m.name, duration: `${m.duration.toFixed(0)}ms` }))
      );
    }

    // Log navigation timing
    const navTiming = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (navTiming) {
      console.log("[PERF] Navigation timing:", {
        domContentLoaded: `${navTiming.domContentLoadedEventEnd.toFixed(0)}ms`,
        domComplete: `${navTiming.domComplete.toFixed(0)}ms`,
        loadComplete: `${navTiming.loadEventEnd.toFixed(0)}ms`,
      });
    }
  } catch {
    // Ignore errors in performance logging
  }
};

// Log performance after load
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    // Delay to ensure all measures are captured
    setTimeout(logPerformance, 1000);
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
